import React from 'react'
import { useTemplatePreviewSettings } from '../context/TemplatePreviewContext'

export default function GeneratedPdfPreviewModal({ isOpen, pdfUrl, title, onClose, onDownload }) {
  const { previewZoom } = useTemplatePreviewSettings()

  if (!isOpen || !pdfUrl) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/60 p-4" onClick={onClose}>
      <div
        className="mx-auto flex h-full w-full max-w-[980px] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-200 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 px-5 py-3 text-white">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">Generated PDF Preview</p>
            <h2 className="text-lg font-semibold">{title}</h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onDownload}
              className="rounded-md border border-white/20 px-3 py-1 text-sm font-medium text-white transition hover:bg-white/10"
            >
              Download
            </button>
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-white/20 px-3 py-1 text-sm font-medium text-white transition hover:bg-white/10"
            >
              Close
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto bg-slate-950/5 p-2 md:p-4">
          <div className="mx-auto" style={{ width: '210mm', minWidth: '210mm', minHeight: '297mm', zoom: previewZoom }}>
            <iframe src={pdfUrl} className="h-[297mm] w-full rounded-lg border border-slate-200 bg-white" title={title} />
          </div>
        </div>
      </div>
    </div>
  )
}
